import React, { useEffect, useLayoutEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../components/SidebarComponent/Sidebar/Sidebar";
import Footer from "../components/footer/Footer";
import AuthNav from "../components/nav/AuthNav";
import SourceContainerComponent from "../components/MainChatPlatformComponent/SourceContainerComponent/SourceContainerComponent";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { useAppDispatch } from "../redux/useAppDispatch";
import { isUserLoggedIn } from "../services/auth/AuthApi";

function AuthLayout(props: any) {
  const [isToggle, setIsToggle] = useState(true);
  const openSidebar = () => {
    setIsToggle(false);
  };
  const closeSidebar = () => {
    setIsToggle(true);
  };

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    const checkUserLogin = async () => {
      // setLoading(true);
      const status = await isUserLoggedIn();

      setIsAuthenticated(status);
      setLoading(false);
    };
    checkUserLogin();
  }, []);

  useEffect(() => {
    window.onresize = () => {
      if (window.innerWidth > 768) {
        setIsToggle(true);
      }
    };
  }, []);

  if (loading) {
    return (
      <div
        className="app"
        style={{ textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  return isAuthenticated ? (
    <div className="app">
      {/* <AuthNav /> */}
      <Sidebar
        isToggle={isToggle}
        closeSidebar={() => closeSidebar()}
      />
      <div className="d-flex flex-column w-100 h-100 overflow-hidden">
        <AuthNav
          openSidebar={() => openSidebar()}
          closeSidebar={() => closeSidebar()}
        />

        <Outlet />
      </div>
      {/* <Footer /> */}
    </div>
  ) : (
    // <Redirect/>
    <Navigate to={"/no-access"} />
  );
}

export default AuthLayout;
